import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, map, take } from 'rxjs';
import { ApplicationAttachment } from '../shared/types/attachment.types';
import { ServiceBase } from './servicebase.service';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService extends ServiceBase {

  attachmentTypesSubj: BehaviorSubject<ServerModels.ENESS_REF_AttachmentTypes[]> = new BehaviorSubject<ServerModels.ENESS_REF_AttachmentTypes[]>([]);

  public getAllAttachmentTypes(): void {
    this.http.get<ServerModels.ENESS_REF_AttachmentTypes[]>(`${this.apiRoot}/api/Attachments/GetAllAttachmentTypes`, this.httpOptions).pipe(
      take(1),
      map((types: ServerModels.ENESS_REF_AttachmentTypes[]) => this.attachmentTypesSubj.next(types))
    ).subscribe();
  }

  public getAttachmentByType(attachmentType: ApplicationAttachment): Observable<ServerModels.ENESS_ApplicationAttachment> {
    return this.http.get<ServerModels.ENESS_ApplicationAttachment>(`${this.apiRoot}/api/Attachments/GetAttachmentByType`, {
      headers: this.httpOptions.headers,
      params: {
          'attachmentType': attachmentType
        }
    }).pipe(catchError(this.swallowError<any>('getAttachmentByType', 'defaultMsg', null, null)));;
  }

  public downloadHelpDocument(filetype: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.apiRoot}/api/Attachments/Help/Download`,
      {
        observe: "response",
        responseType: 'blob',
        params: {
          filetype: filetype
        }
      }).pipe(catchError(this.swallowError<any>('downloadHelpDocument', 'defaultMsg', null, null)));;
  }
}
